// Ardor Banner Builder: app layout. Ardor Printing.
// Turns the banner builder into a one-screen editor that matches the sticker builder (tool rail, big canvas,
// options panel with the total and Add to cart at the bottom) and the tent builder (2D/3D switch, 3D thumbnail,
// floating toolbar). It only moves existing builder elements, so prices, proof, cart and quote work as before.
// Loaded by sections/ardor-banner-builder-v2.liquid after ardor-banner-builder-v2.js.
(function () {
'use strict';
var root = document.querySelector('[data-abb-root]');
if (!root || root.__abx) return;

var $ = function (s, el) { return (el || root).querySelector(s); };
var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
var steps = $$('.abb-step');
var wrap = $('.abb-wrap'), grid = $('.abb-grid'), head = $('.abb-head'), crumbs = $('.abb-crumbs');
var viewer = $('[data-abb-viewer]'), frame = $('.abb-layout__frame'), priceBox = $('.abb-price');
if (!wrap || !grid || !viewer || !frame || !priceBox || steps.length < 7) return; // keep the normal layout
root.__abx = true;
root.classList.add('abb--app');

var P = 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
function svg(d, s) { return '<svg viewBox="0 0 24 24" width="' + (s || 22) + '" height="' + (s || 22) + '" ' + P + ' aria-hidden="true" focusable="false">' + d + '</svg>'; }
var I = {
art: '<path d="M12 15V4M7.5 8.5 12 4l4.5 4.5"/><path d="M4 15v3.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V15"/>',
design: '<path d="M12 3l1.8 4.6L18.5 9l-4.7 1.4L12 15l-1.8-4.6L5.5 9l4.7-1.4z"/><path d="M18.5 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>',
quote: '<path d="M4 5h16v11H9l-5 4z"/><path d="M8 9.5h8M8 12.5h5"/>',
cube: '<path d="M12 2.8l8 4.5v9.4l-8 4.5-8-4.5V7.3z"/><path d="M12 21.2v-9.4M20 7.3l-8 4.5-8-4.5"/>',
flat: '<rect x="3" y="6" width="18" height="12" rx="1.5"/><circle cx="6" cy="9" r=".9"/><circle cx="18" cy="9" r=".9"/><circle cx="6" cy="15" r=".9"/><circle cx="18" cy="15" r=".9"/>',
x: '<path d="M6 6l12 12M18 6 6 18"/>',
up: '<path d="M12 15V4M7.5 8.5 12 4l4.5 4.5"/><path d="M4 15v3.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V15"/>',
chev: '<path d="M9 6l6 6-6 6"/>'
};
function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
function move(node, to, before) { if (node && to) to.insertBefore(node, before || null); return node; }

// ---------- build the app shell ----------
var app = el('div', 'abx');
app.innerHTML =
'<nav class="abx-rail" aria-label="Banner tools">' +
'<button type="button" class="abx-tool" data-abx-fly="art">' + svg(I.art) + '<span>Artwork</span></button>' +
'<button type="button" class="abx-tool" data-abx-fly="design">' + svg(I.design) + '<span>Design help</span></button>' +
'<button type="button" class="abx-tool" data-abx-quote>' + svg(I.quote) + '<span>Quote</span></button>' +
'</nav>' +
'<section class="abx-stage" data-abx-stage aria-label="Your banner">' +
'<div class="abx-2d" data-abx-2d>' +
'<div class="abx-empty" data-abx-empty><div class="abx-empty__card">' +
'<span class="abx-empty__icon">' + svg(I.up, 22) + '</span>' +
'<h3 class="abx-empty__title">Drop your banner art here</h3>' +
'<p class="abx-empty__text">JPG, PNG, PDF, AI, EPS, TIFF or PSD, up to 25 MB. You\'ll see it on your banner right away.</p>' +
'<div class="abx-empty__btns"><button type="button" class="abx-btn abx-btn--yellow" data-abx-upload>Upload artwork</button>' +
'<button type="button" class="abx-btn abx-btn--ghost" data-abx-fly="design">Have us design it</button></div>' +
'<p class="abx-empty__note">No artwork? Our designers lay it out for $50 and email you a proof.</p>' +
'</div></div>' +
'</div>' +
'<div class="abx-3d" data-abx-3d><button type="button" class="abx-hit" data-abx-hit aria-label="Open the 3D preview"></button><span class="abx-badge">' + svg(I.cube, 13) + '3D</span></div>' +
'<div class="abx-mode" role="group" aria-label="Preview">' +
'<button type="button" data-abx-mode="2d">' + svg(I.flat, 16) + '2D</button>' +
'<button type="button" data-abx-mode="3d">' + svg(I.cube, 16) + '3D</button>' +
'</div>' +
'<p class="abx-hint" data-abx-hint></p>' +
'<div class="abx-bar" data-abx-bar><button type="button" class="abx-tbtn" data-abx-upload>' + svg(I.up, 17) + '<span data-abx-upload-label>Upload</span></button></div>' +
'</section>' +
'<aside class="abx-panel" aria-label="Banner options">' +
'<div class="abx-panel__head"><h2 class="abx-panel__title">Custom Banner</h2><p class="abx-panel__sub" data-abx-sub></p></div>' +
'<div class="abx-panel__body" data-abx-body></div>' +
'<div class="abx-foot" data-abx-foot>' +
'<div class="abx-foot__row"><span class="abx-foot__label">Total</span></div>' +
'<div class="abx-foot__btns"></div>' +
'</div>' +
'</aside>' +
'<div class="abx-fly" data-abx-flyout hidden role="dialog" aria-label="Artwork">' +
'<div class="abx-fly__head"><h2 data-abx-fly-title>Artwork</h2><button type="button" class="abx-x" data-abx-fly-close aria-label="Close">' + svg(I.x, 20) + '</button></div>' +
'<div class="abx-fly__body" data-abx-fly-body></div>' +
'</div>';

var stage = $('[data-abx-stage]', app), box2d = $('[data-abx-2d]', app), box3d = $('[data-abx-3d]', app);
var body = $('[data-abx-body]', app), foot = $('[data-abx-foot]', app), bar = $('[data-abx-bar]', app);
var fly = $('[data-abx-flyout]', app), flyBody = $('[data-abx-fly-body]', app);
var empty = $('[data-abx-empty]', app), hint = $('[data-abx-hint]', app), sub = $('[data-abx-sub]', app);

// stage: 2D layout canvas and the 3D viewer
move(frame, box2d, empty);
move(viewer, box3d, box3d.firstChild);

// 2D toolbar: front/back tabs, art size and placement, upload or replace
var tabs = $('[data-abb-art-tabs]'), ctl = $('[data-abb-layout-controls]');
move(tabs, bar, bar.firstChild);
move(ctl, bar, bar.lastChild);

// options panel: size, material, sides, edges, extras, quantity and delivery
[0, 1, 2, 4, 5, 6].forEach(function (i) { move(steps[i], body); });
var rush = $('.abb-price__rush', priceBox); if (rush) move(rush, body);

// footer: alerts, total, Add to cart and quote
var fRow = $('.abx-foot__row', foot), fBtns = $('.abx-foot__btns', foot);
move($('[data-abb-warn]', priceBox), foot, fRow);
move($('[data-abb-error]', priceBox), foot, fRow);
move($('[data-abb-total]', priceBox), fRow);
move($('[data-abb-each]', priceBox), foot, fBtns);
move($('.abb-price__free', priceBox), foot, fBtns);
var quoteBtn = $('[data-abb-quote]', priceBox), addBtn = $('[data-abb-add]', priceBox);
if (quoteBtn) {
quoteBtn.className = 'abx-icon-btn';
quoteBtn.setAttribute('aria-label', 'Request a quote'); quoteBtn.title = 'Request a quote';
quoteBtn.innerHTML = svg(I.quote, 22);
move(quoteBtn, fBtns);
}
move(addBtn, fBtns);

// artwork flyout: upload, back art, design help, notes
var artStep = steps[3];
move(artStep, flyBody);
var designCard = $('[data-abb-design]') && $('[data-abb-design]').closest('label');

// page text goes under the builder, like the sticker builder page
var below = el('div', 'abx-below');
if (crumbs) move(crumbs, below);
if (head) move(head, below);
move($('.abb-stage-note'), below);
wrap.insertBefore(app, grid);
wrap.insertBefore(below, grid);

// ---------- state ----------
var state = { mode: '2d', fly: '' };
function apply() {
app.setAttribute('data-mode', state.mode);
box2d.className = 'abx-2d ' + (state.mode === '2d' ? 'is-full' : 'is-off');
box3d.className = 'abx-3d ' + (state.mode === '3d' ? 'is-full' : 'is-thumb');
$('[data-abx-hit]', app).hidden = state.mode === '3d';
$$('[data-abx-mode]', app).forEach(function (b) { var on = b.getAttribute('data-abx-mode') === state.mode; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
fly.hidden = !state.fly;
app.setAttribute('data-fly', state.fly ? '1' : '0');
$$('.abx-rail [data-abx-fly]', app).forEach(function (b) { var on = b.getAttribute('data-abx-fly') === state.fly; b.classList.toggle('is-on', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
$('[data-abx-fly-title]', app).textContent = state.fly === 'design' ? 'Design help' : 'Artwork';
if (designCard) designCard.classList.toggle('abx-glow', state.fly === 'design');
try { window.dispatchEvent(new Event('resize')); } catch (e) {}
}
function setMode(m) { state.mode = m; apply(); }
function openFly(which, focusEl) {
state.fly = which; apply();
var t = focusEl || (which === 'design' ? designCard : null);
if (t) setTimeout(function () { reveal(t); }, 40);
}
function closeFly() { state.fly = ''; apply(); } function reveal(n) { var b = n && n.closest('.abx-panel__body, .abx-fly__body'); if (!b) return; var r = n.getBoundingClientRect(), br = b.getBoundingClientRect(); if (r.bottom > br.bottom) b.scrollTop += r.bottom - br.bottom + 8; else if (r.top < br.top) b.scrollTop -= br.top - r.top + 8; }

app.addEventListener('click', function (e) {
var t = e.target.closest('button'); if (!t || !app.contains(t)) return;
if (t.hasAttribute('data-abx-mode')) { setMode(t.getAttribute('data-abx-mode')); return; }
if (t.hasAttribute('data-abx-hit')) { setMode('3d'); return; }
if (t.hasAttribute('data-abx-fly')) {
var w = t.getAttribute('data-abx-fly');
if (state.fly === w && t.closest('.abx-rail')) { closeFly(); return; }
if (w === 'design' && t.closest('.abx-empty') && design && !design.checked) design.click();
openFly(w); return;
}
if (t.hasAttribute('data-abx-fly-close')) { closeFly(); return; }
if (t.hasAttribute('data-abx-upload')) { var inp = $('[data-abb-file]'); if (inp) inp.click(); return; }
if (t.hasAttribute('data-abx-quote')) { if (quoteBtn) quoteBtn.click(); return; }
});
document.addEventListener('keydown', function (e) {if (e.key !== 'Escape' || document.querySelector('dialog[open]')) return;if (state.fly) closeFly(); else if (openRow) toggleRow(openRow, false);});

// ---------- compact option rows: one tight row per option, long lists open under their row ----------
var openRow = null;
var rowsEl = el('div', 'abx-rows');
body.insertBefore(rowsEl, body.firstChild);
[0, 1, 2, 4, 5, 6].forEach(function (i) { steps[i].classList.add('abx-gone'); });
function txt(n) { return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; }
function pressed(c) { return c ? $('.abb-opt[aria-pressed="true"]', c) : null; }
function row(key, label, cls) {
var r = el('div', 'abx-row' + (cls ? ' ' + cls : ''), '<span class="abx-row__label">' + label + '</span>');
r.setAttribute('data-abx-row', key);
rowsEl.appendChild(r);
return r;
}
function toggleRow(r, force) {
var open = force == null ? r._drop.hidden : force;
if (open && openRow && openRow !== r) toggleRow(openRow, false);
r._drop.hidden = !open;
r._btn.setAttribute('aria-expanded', open ? 'true' : 'false');
r.classList.toggle('is-open', open);
if (open) { openRow = r; setTimeout(function () { reveal(r); }, 0); }
else if (openRow === r) openRow = null;
}
function picker(key, label, parts, summary, keepOpen) {
var r = row(key, label, 'abx-row--pick');
var btn = el('button', 'abx-pick'); btn.type = 'button'; btn.setAttribute('aria-expanded', 'false');
var drop = el('div', 'abx-drop'); drop.hidden = true;
r.appendChild(btn); r.appendChild(drop);
r._btn = btn; r._drop = drop;
parts.forEach(function (p) { if (p) drop.appendChild(p); });
var sync = function () { btn.innerHTML = '<span class="abx-pick__val">' + summary() + '</span>' + svg(I.chev, 16); };
btn.addEventListener('click', function () { toggleRow(r); });
drop.addEventListener('click', function (e) { var b = e.target.closest('.abb-opt'); if (b && !keepOpen(b)) setTimeout(function () { toggleRow(r, false); }, 0); });
parts.forEach(function (p) { if (p) new MutationObserver(sync).observe(p, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'hidden', 'disabled'] }); });
sync();
return r;
}
function bindHidden(r, src) {
if (!src) return;
var f = function () { r.hidden = !!src.hidden; if (r.hidden && openRow === r) toggleRow(r, false); };
new MutationObserver(f).observe(src, { attributes: true, attributeFilter: ['hidden'] });
f();
}

// size: W and H on one line, popular sizes in one strip
var rSize = row('size', 'Size');
var sizeBox = $('.abb-size', steps[0]);
if (sizeBox) {
move(sizeBox, rSize);
$$('.abb-field', sizeBox).forEach(function (f, i) {
var lab = $('.abb-field__label', f); if (lab) lab.textContent = i ? 'H' : 'W';
var inp = $('input', f); if (inp) inp.setAttribute('aria-label', i ? 'Height in feet' : 'Width in feet');
f.appendChild(el('span', 'abx-unit', 'ft'));
});
}
var strip = $('[data-abb-sizes]'); if (strip) { strip.classList.add('abx-strip'); move(strip, rSize); }

// material
var mats = $('[data-abb-mats]');
picker('mat', 'Material', [$('.abb-help', steps[1]), mats], function () {
var on = pressed(mats);
return on ? '<strong>' + esc(txt($('.abb-opt__name', on))) + '</strong><em>' + esc(txt($('.abb-opt__price', on))) + '</em>' : '';
}, function () { return false; });

// printed sides: a two-button switch
var rSides = row('sides', 'Sides');
move($('[data-abb-sides]'), rSides);
var sNote = $('[data-abb-sides-note]');
if (sNote) {
move(sNote, rSides);
var quiet = function () { sNote.classList.toggle('abx-quiet', /^Printed on the front/.test(txt(sNote))); };
new MutationObserver(quiet).observe(sNote, { childList: true, characterData: true, subtree: true });
quiet();
}

// edges and hanging
var grom = $('[data-abb-grommets]'), gNote = $('[data-abb-grommet-note]');
var hemLine = $('[data-abb-hem-label]') && $('[data-abb-hem-label]').parentNode;
picker('grommets', 'Grommets', [hemLine, grom], function () {
return esc(gNote && !gNote.hidden ? 'None (pole pockets)' : txt(pressed(grom)));
}, function () { return false; });
var poleWrap = $('[data-abb-pole-wrap]'), poles = $('[data-abb-poles]'), poleSizes = $('[data-abb-pole-sizes]');
var rPole = picker('pole', 'Pole pockets', [poles, poleSizes], function () {
var p = txt(pressed(poles)), sz = poleSizes && !poleSizes.hidden ? txt(pressed(poleSizes)).replace(/ \(.*\)$/, '') : '';
return esc(p + (sz ? ', ' + sz : ''));
}, function (b) { return poles.contains(b) && txt(b) !== 'None'; });
bindHidden(rPole, poleWrap);

// extras: webbing, rope, wind slits, reinforced corners
var webWrap = $('[data-abb-webbing-wrap]'), ropeWrap = $('[data-abb-rope-wrap]'), toggles = $('[data-abb-toggles]');
var rExtras = picker('extras', 'Extras', [webWrap, ropeWrap, toggles], function () {
var out = [];
[[webWrap, $('[data-abb-webbings]')], [ropeWrap, $('[data-abb-ropes]')]].forEach(function (w) {
if (!w[1] || (w[0] && w[0].hidden)) return;
var t = txt(pressed(w[1])); if (t && t !== 'None') out.push(t);
});
if (toggles) $$('.abb-opt[aria-pressed="true"]', toggles).forEach(function (b) { out.push(txt(b)); });
return esc(out.length ? out.join(', ') : 'None');
}, function () { return true; });
bindHidden(rExtras, $('[data-abb-extras-wrap]'));

// quantity and delivery
var rQty = row('qty', 'Quantity');
move($('.abb-qty', steps[6]), rQty);
var rDel = row('delivery', 'Delivery <span class="abx-req">Required</span>', 'abx-row--stack');
move($('.abb-delivery', steps[6]), rDel);
if (gNote) move(gNote, rowsEl.querySelector('[data-abx-row="grommets"]'));
function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

// ---------- live labels ----------
var chips = ['[data-abb-chip-size]', '[data-abb-chip-mat]', '[data-abb-chip-sides]'].map(function (s) { return $(s); });
function syncSub() {
var txt = chips.map(function (c) { return c ? c.textContent.trim() : ''; }).filter(Boolean);
sub.textContent = txt.join(' · ');
hint.textContent = (txt[0] ? txt[0] + ' · ' : '') + 'Keep words and logos inside the dashed red line';
}
chips.forEach(function (c) { if (c) new MutationObserver(syncSub).observe(c, { childList: true, characterData: true, subtree: true }); });
syncSub();

// ---------- empty canvas card ----------
var fileName = $('[data-abb-file-name]'), design = $('[data-abb-design]'), backSame = $('[data-abb-back-same]');
var upLabel = $('[data-abx-upload-label]', app);
function syncEmpty() {
var hasArt = fileName && !fileName.hidden;
var onBack = tabs && !tabs.hidden && $('[data-abb-face="back"][aria-pressed="true"]', tabs);
var same = onBack && backSame && backSame.checked;
var noArt = !hasArt && !(design && design.checked) && !same;
empty.hidden = !noArt;
app.classList.toggle('abx-has-art', !!hasArt);
if (upLabel) upLabel.textContent = hasArt ? 'Replace art' : 'Upload';
}
if (fileName) new MutationObserver(syncEmpty).observe(fileName, { attributes: true, attributeFilter: ['hidden'] });
if (tabs) new MutationObserver(syncEmpty).observe(tabs, { attributes: true, subtree: true, attributeFilter: ['hidden', 'aria-pressed'] });
root.addEventListener('change', function () { setTimeout(syncEmpty, 0); });
syncEmpty();

// ---------- drop a file anywhere on the canvas ----------
function hasFiles(e) { try { return Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') >= 0; } catch (er) { return false; } }
stage.addEventListener('dragover', function (e) { if (!hasFiles(e)) return; e.preventDefault(); stage.classList.add('is-over'); });
stage.addEventListener('dragleave', function (e) { if (!stage.contains(e.relatedTarget)) stage.classList.remove('is-over'); });
stage.addEventListener('drop', function (e) {
if (!hasFiles(e)) return;
e.preventDefault(); stage.classList.remove('is-over');
var inp = $('[data-abb-file]'), f = e.dataTransfer.files && e.dataTransfer.files[0];
if (!inp || !f) return;
try { var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files; } catch (er) { return; }
inp.dispatchEvent(new Event('change', { bubbles: true }));
});

// ---------- point customers to whatever needs fixing ----------
var errEl = $('[data-abb-error]');
if (errEl) new MutationObserver(function () {
if (errEl.hidden) return;
var t = errEl.textContent;
if (/artwork|design it|for the back/i.test(t)) openFly('art', $('[data-abb-drop]'));
else closeFly();
}).observe(errEl, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });

/* ---------- Match art size: keep the banner's longest side, set the other side to the artwork's shape (Oct 5, 2026) ---------- */
var ctlRow = ctl && $('.abb-row', ctl), matchBtn = el('button', 'abb-mini abx-match', svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>', 15) + '<span>Match art size</span>');
matchBtn.type = 'button'; matchBtn.title = 'Change the banner size to the shape of your artwork'; if (ctlRow) ctlRow.insertBefore(matchBtn, ctlRow.firstChild);
function niceFt(x) { var half = Math.round(x * 2) / 2, inch = Math.round(x * 12) / 12, v = Math.abs(half - x) <= x * 0.01 ? half : Math.abs(inch - x) <= x * 0.01 ? inch : x; return Math.round(v * 100) / 100; }
function sizeFor(r, W, H) { var L = Math.max(W, H), w = r >= 1 ? L : niceFt(L * r), h = r >= 1 ? niceFt(L / r) : L; if (Math.min(w, h) < 1) { w = r >= 1 ? niceFt(r) : 1; h = r >= 1 ? 1 : niceFt(1 / r); } return { w: Math.min(100, w), h: Math.min(100, h) }; }
function say(msg) { clearTimeout(say.t); setTimeout(function () { hint.textContent = msg; say.t = setTimeout(syncSub, 4000); }, 30); }
matchBtn.addEventListener('click', function () { var a = root.__abbArtSize && root.__abbArtSize(), wI = $('[data-abb-w]'), hI = $('[data-abb-h]'); if (!a || !(a.w > 1) || !(a.h > 1) || !wI || !hI) { say("We couldn't read your artwork's shape. Type the size you want instead."); return; } var W = parseFloat(wI.value) || 6, H = parseFloat(hI.value) || 3, s = sizeFor(a.w / a.h, W, H); if (s.w === W && s.h === H) { say('Your banner already matches your artwork'); return; } wI.value = String(s.w); wI.dispatchEvent(new Event('input', { bubbles: true })); hI.value = String(s.h); hI.dispatchEvent(new Event('input', { bubbles: true })); var f = $('[data-abb-fill]'); if (f) f.click(); say('Resized to match your artwork: ' + s.w + ' ft × ' + s.h + ' ft'); });
apply();
})();
